<template>
  <div>
    <div class="steps">
      <b-link to="/cart">1</b-link>
      <b-link to="/cart/step2" :disabled="cart === 0">2</b-link>
      <b-link to="/cart/step3" :disabled="cart === 0">3</b-link>
      <b-link to="/cart/step4" :disabled="cart === 0">4</b-link>
      <b-link to="/cart/step5" :disabled="cart === 0">5</b-link>
    </div>
    <div class="d-flex justify-content-between mt-3 steps-labels">
      <div>Carrito</div>
      <div>Datos</div>
      <div>Envío</div>
      <div>Pago</div>
      <div>Listo</div>
    </div>

    <router-view @change="updateformData($event)"></router-view>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data(){
    return{
      formData: {}
    }
  },
  computed: {
    ...mapGetters({ cart: "countCartItems" })
  },
  methods:{
    updateformData(formData){
      this.formData = Object.assign(this.formData, formData);
    }
  }
};
</script>
